var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-popup"},[_vm._l((_vm.effectList),function(item){return [(item.key == _vm.isKey && item.com)?_c(item.com,{key:item.key,tag:"component",attrs:{"args":item.args}}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }